import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

import { CancelExamEventForm } from '../../components';

import { CancelExamEventFormSchema, type CancelExamEventFormType } from './schema';

interface CancelExamEventLogicProps {
  onSubmit: (reason: string) => void;
  onClose: () => void;
}

export default function CancelExamEventLogic(props: Readonly<CancelExamEventLogicProps>) {
  const { onSubmit, onClose } = props;

  const formContext = useForm<CancelExamEventFormType>({
    resolver: zodResolver(CancelExamEventFormSchema),
  });

  const handleSubmit = async (data: CancelExamEventFormType) => {
    onSubmit(data.reason);
    onClose();
  };

  return <CancelExamEventForm form={formContext} onSubmit={handleSubmit} onClose={onClose} />;
}
